import { useNavigate } from 'react-router';
import history from '~/browserHistory';
import { Colors } from '~/themes/colors';
import { Icon } from '../Icon';

export default function BackWhiteButtonLegacy({ whiteArrow, containerStyle, backRoute }) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginLeft: 10,
        ...containerStyle,
      }}
      onClick={() => (backRoute ? history.push(backRoute) : navigate(-1))}
    >
      <Icon name="arrow-left" color={whiteArrow ? Colors.white : Colors.secondary_500} size={20} />
      <p
        className="global_font f-dark"
        style={{
          color: Colors.white,
          fontWeight: 'bold',
          fontSize: 22,
          textAlign: 'left',
          width: '100%',
          cursor: 'pointer',
        }}
      >
        Back
      </p>
    </div>
  );
}
